import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/hooks/redux";
import { selectCountries } from "src/redux/countries/selectors";
import { RenderFormFields } from "src/components/RenderFormFields";
import { StepControls } from "../StepControls";
import { getCountryField } from "../constants/fields";
import { registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const CountryOfRegistration: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();

  const { items: countries } = useAppSelector(selectCountries);
  const reprecentionCountriesField = getCountryField(countries);

  return (
    <div className="flex flex-col gap-10">
      <div className={"flex flex-col gap-5 md:gap-10"}>
        <h2 className="font-semibold">
          {t(registrationTitlesTrns.countryOfRegistration)}
        </h2>

        <div>
          <RenderFormFields fields={reprecentionCountriesField} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
